<template>
  <div id="gwi-voucherDetail" class="app bg-gray">
    <div class="scroll to-bottom-btn">
      <section v-if="voucherDetail.cardType === '01'" class="bigger">
        <div class="row myrow">就诊凭证二维码</div>
        <qrcode
          id="voucherDetail-qrcode"
          :size="171"
          class="qrcode"
          :cls="qrCls"
          :value="qrText"
        ></qrcode>
        <!--<o2o-helper :type="0"></o2o-helper>-->
      </section>
      <section>
        <dl class="field">
          <dt>就诊类型</dt>
          <dd>{{ voucherDetail.cardType | cardType }}</dd>
        </dl>
        <dl class="field">
          <dt>姓名</dt>
          <dd>{{ voucherDetail.holderName }}</dd>
        </dl>
        <dl class="field">
          <dt>卡号</dt>
          <dd>{{ voucherDetail.cardNo | dotted }}</dd>
        </dl>
        <dl class="field" v-show="localChanel !== 'TFY'">
          <dt>手机号</dt>
          <dd>{{ voucherDetail.mobileNo | dotted }}</dd>
        </dl>
      </section>
    </div>
    <footer>
      <button
        id="voucherDetail-btn-delete"
        class="btn-logout"
        type="button"
        @click="showConfirm = true"
      >
        解&nbsp;&nbsp;绑
      </button>
    </footer>
    <confirm
      text="确认解绑该凭证？"
      v-model="showConfirm"
      @on-sure="deleteVoucher"
    ></confirm>
  </div>
</template>
<script>
import Qrcode from 'v-qrcode'
import Confirm from 'Confirm'
import O2oHelper from 'O2OHelper'
import voucherService from 'voucher.service'
export default {
  props: ['voucher'],
  mounted () {
    this.voucherDetail = this.$store.state.paramModule.param.detail.voucher;
    if (this.voucherDetail.cardType === '01') {
      this.getQrCode()
    }
  },
  components: {
    Qrcode,
    Confirm,
    O2oHelper
  },
  data () {
    return {
      localChanel: localStorage.channel,
      voucherDetail: {},
      qrCls: 'qrcode',
      qrText: '',
      showConfirm: false
    }
  },
  methods: {
    deleteVoucher () {
      voucherService.deleteVoucher({
        cardType: this.voucherDetail.cardType,
        cardNo: this.voucherDetail.cardNo
      }).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg)
          return
        }
        this.$router.back()
      })
    },
    getQrCode () {
      // 首先尝试从之前的就诊凭证列表接口中获取二维码
      if (this.voucherDetail.qrCode) {
        this.qrText = this.voucherDetail.qrCode
        return
      }
      // 如果没有获取到二维码，则调用接口查二维码
      voucherService.getVoucherQrCode({
        idCard: this.voucherDetail.cardNo,
      }).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg)
          return
        }
        this.qrText = res.data.qrCode
      })
    }
  }
}
</script>
<style lang="scss">
.row.myrow {
  padding: 0.5rem 0 0.5rem 0.8rem;
}
</style>



// WEBPACK FOOTER //
// VoucherDetail.vue?74d2155a